import { motion } from "framer-motion";

import { Spinner } from "@/atoms";
import { cn } from "@/lib/utils";

type LoaderProps = {
  fullScreen?: boolean;
  visible?: boolean;
  className?: string;
};

export default function Loader({
  fullScreen,
  visible,
  className,
}: LoaderProps): React.ReactElement | null {
  if (!visible) return null;
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.25 } }}
      exit={{ opacity: 0, transition: { duration: 0.25 } }}
      className={cn(
        "relative z-10 flex items-center justify-center",
        fullScreen && "fixed bottom-0 left-0 right-0 top-0 z-20 bg-black/20",
        className,
      )}
      data-testid="Loader"
    >
      <Spinner />
    </motion.div>
  );
}
